import React from 'react';
import { Sun, Moon, Laptop } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuCheckboxItem,
} from './ui/dropdown-menu';

export default function ThemeToggle({ compact = true }) {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const Icon = resolvedTheme === 'light' ? Sun : Moon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="w-9 h-9 rounded-full grid place-items-center hover:bg-white/5 text-[var(--theme-fg)] transition-colors"
          aria-label="Toggle theme"
          data-testid="theme-toggle"
        >
          <Icon className="w-4.5 h-4.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[var(--theme-surface)] border-white/10 text-[var(--theme-fg)] w-44">
        <DropdownMenuCheckboxItem checked={theme === 'light'} onCheckedChange={() => setTheme('light')} data-testid="theme-light">
          <Sun className="w-4 h-4 mr-2" /> Light
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem checked={theme === 'dark'} onCheckedChange={() => setTheme('dark')} data-testid="theme-dark">
          <Moon className="w-4 h-4 mr-2" /> Dark
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem checked={theme === 'system'} onCheckedChange={() => setTheme('system')} data-testid="theme-system">
          <Laptop className="w-4 h-4 mr-2" /> System
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
